/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

const initialState = {
  page: '',
};

export const navigate = (location) => (dispatch) => {
  // Extract the page name from path.
  // Any other info you might want to extract from the path (like page type),
  // you can do here.
  const {pathname} = location;
  const parts = pathname.slice(1).split('/');
  const page = parts[0] || 'public'   // set page to public if nothing specificied after /
  // console.log('parts -' + parts)
  const itemId = parts[1];
  // query is extracted from the search string: /explore?q={query}
  const match = RegExp('[?&]q=([^&]*)').exec(location.search);
  //  const query = location.search
  const query = match && decodeURIComponent(match[1].replace(/\+/g, ' '))
  // console.log('query -- ' + query)
  // console.log(match[1])
  // if not in public page and if not signed in then wait for signin
  dispatch(loadPage(page, query, itemId));
  // need to adjust above for handling pages
  // Close the drawer - in case the *path* change came from a link in the drawer.

};

const loadPage = (page,query, itemId) => async (dispatch, getState) => {

let module;
//  fetchUser();
switch(page) {
  case 'public':
    module = await import('../components/paksh-public.js');
    break;

  case 'home':
    module = await import('../components/paksh-home.js');
      break;

  case 'judgelist':
    import('../components/judge-list.js').then(module => {
      dispatch(module.searchJudges(query));
    });
    break;

  case 'judgedetail':
    module = await import('../components/judge-detail.js');
    await dispatch(module.fetchJudge(itemId));       // Fetch the judge info for the given judge id.
    if (isFetchJudgeFailed(getState().judge)) {      // Wait fto check if the judge id is valid.
        page = '404';
      }
  break;

  case 'lawyerlist':
    import('../components/lawyer-list.js').then(module => {
      // Put code in here that you want to run every time when
      // navigating to view1 after my-view1.js is loaded.
      dispatch(module.searchLawyers(query));
    });

    break;

  case 'lawyerdetail':
    module = await import('../components/lawyer-detail.js');
    // console.log("-----lawyerdetail paksh.app----")
    await dispatch(module.fetchLawyer(itemId));
    if (isFetchLawyerFailed(getState().lawyer)) {
      page = '404';
    }
    break;

/*    case 'legalcaselist':
    module = await import('../components/legalcase-filter.js')
    module = await import('../components/legalcase-list.js');
    dispatch(module.searchLegalcases(query));
    break;
*/

  case 'legalcasedetail':
    module = await import('../components/legalcase-detail.js');
    await dispatch(module.fetchLegalcase(itemId));        // Fetch the case info for the given case id.
    if (isFetchLegalcaseFailed(getState().legalcase)) {   // Wait for to check if the case id is valid.
      page = '404';
    }
    break;

  case 'terms':
    module = await import('../components/paksh-terms.js');
    break;

  case 'privacy':
    module = await import('../components/paksh-privacy.js');
    break;

  case 'about':
    module = await import('../components/paksh-about.js');
    break;

  case 'help':
    module = await import('../components/paksh-help.js');
    break;

  case 'signup':
    module = await import('../components/paksh-signup.js');
    break;

  case 'predict':
    module = await import('../components/paksh-view4.js');
    break;

default:
page = 'view404';
import('../components/paksh-view404.js');
}
dispatch(pageUpdated(page));
};



const isFetchJudgeFailed = (judge) => !judge.isFetching && judge.failure;

const isFetchLawyerFailed = (lawyer) => !lawyer.isFetching && lawyer.failure;

const isFetchLegalcaseFailed = (legalcase) => !legalcase.isFetching && legalcase.failure;


export const updateLayout = (wide) => (dispatch, getState) => {
};

export const updateLocationURL = (url) => (dispatch) => {
window.history.pushState({}, '', url);
// console.log("---in updateLocation")
dispatch(navigate(window.location));
};

export const refreshPage = () => (dispatch, getState) => {
const state = getState();
// load page using the current state
// console.log('refersh page' + state.app.page)   // -- TODO:  CHECK THIS IF NEEDS TO BE TWEAKED TO CALL FOR DIFF PAGES
if (state.app.page === 'judgelist' || state.app.page === 'judgedetail') {
  dispatch(loadPage(state.app.page, state.judges && state.judges.query, state.judge && state.judge.id));
}
else if (state.app.page === 'lawyerlist' || state.app.page === 'lawyerdetail') {
  dispatch(loadPage(state.app.page, state.lawyers && state.lawyers.query, state.lawyer && state.lawyer.id));
}
else if (state.app.page === 'legalcaselist' || state.app.page === 'legalcasedetail') {
  dispatch(loadPage(state.app.page, state.legalcases && state.legalcases.query, state.legalcase && state.legalcase.id));
}
else {
  //
}
//  dispatch(loadPage(state.app.page, state.client && state.clients.query, state.legalcases && state.legalcases.query, state.judge && state.judge.id));

};


export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    pageUpdated(state, action) {
      state.page = action.payload
    },
  }
})

export const { pageUpdated } = appSlice.actions

// Export the slice reducer as the default export
export default appSlice.reducer